import { RESET_PASSWORD_VERIFY_EMAIL_PATH } from '../../../react-router-paths';
import { AlternativeContactLinkProps } from '../alternative-contact-link';

export const emailContactLinkProps: AlternativeContactLinkProps = {
    contactType: 'email',
    to: RESET_PASSWORD_VERIFY_EMAIL_PATH,
    replace: true
};
